import { useCallback, useEffect, useRef, useState } from 'react';
import { SchedulePulseTab, useSchedulePulseShallowStore } from '../../../../../../stores/schedule-pulse.store';

export const useOpenedRequestLocation = () => {
  const { selectedRequestLocationId, setSelectedRequestLocationId, selectedTab } = useSchedulePulseShallowStore(
    'selectedRequestLocationId',
    'setSelectedRequestLocationId',
    'selectedTab'
  );
  const isMounted = useRef(false);
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);

  useEffect(() => {
    if (isMounted.current) {
      if (selectedRequestLocationId && selectedTab === SchedulePulseTab.AppointmentRequests) {
        setSelectedLocation(selectedRequestLocationId);
      }
    } else {
      isMounted.current = true;
    }
  }, [selectedRequestLocationId, selectedTab]);

  const setSelectedLocationId = useCallback(
    (locationId: string | null) => {
      if (locationId) {
        setSelectedLocation(locationId);
      } else {
        setSelectedLocation(null);
      }
      setSelectedRequestLocationId(null);
    },
    [setSelectedRequestLocationId]
  );

  return { selectedLocation, setSelectedLocation: setSelectedLocationId };
};
